module.exports = require("./lib/_stream_duplex.js")



//////////////////
// WEBPACK FOOTER
// ./~/stream-browserify/~/readable-stream/duplex.js
// module id = 1735
// module chunks = 1